import { queryOptions } from '@tanstack/react-query';

import { getContactQuery, getContactsQuery } from './shared';

export const getContactQueryOptions = (id: string) => queryOptions(getContactQuery(id));
export const getContactsQueryOptions = () => queryOptions(getContactsQuery());
